"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBonusResults = getBonusResults;
const openapi_1 = require("@pentacode/openapi");
const utils_1 = require("../utils");
const payroll_1 = require("../payroll");
const model_1 = require("../model");
const interval_1 = require("./interval");
const consts_1 = require("./consts");
function getBonusResults(company, employee, entry, work) {
    var _a;
    const contract = employee.getContractForDate(entry.date);
    if (!contract) {
        return [];
    }
    const bonuses = [];
    for (const bonus of contract.bonuses) {
        const type = (_a = company.bonusTypes) === null || _a === void 0 ? void 0 : _a.find((t) => t.id === bonus.typeId);
        if (!type || (bonus.positionId && entry.positionId !== bonus.positionId)) {
            continue;
        }
        const mustStartBefore = type.shiftMustStartBefore && (0, utils_1.parseTime)(entry.date, type.shiftMustStartBefore);
        if (mustStartBefore && entry.start >= mustStartBefore) {
            continue;
        }
        const matchingDates = type.mode === model_1.BonusTypeMode.Daily
            ? [entry.date]
            : [entry.date, (0, utils_1.dateAdd)(entry.date, { days: 1 })].filter((date) => type.matchesDate(date, company.country));
        let intervals = [];
        for (const date of matchingDates) {
            intervals.push(...type.intervals.map(([start, end]) => [(0, utils_1.parseTime)(date, start), (0, utils_1.parseTime)(date, end)]));
        }
        if (!intervals.length) {
            continue;
        }
        intervals = (0, interval_1.union)(...intervals);
        bonuses.push({
            bonus,
            type,
            intervals,
        });
    }
    for (const bonus of bonuses) {
        for (const override of bonus.type.overrides) {
            const otherBonuses = bonuses.filter((b) => b.type.id === override.objectId);
            for (const otherBonus of otherBonuses) {
                otherBonus.intervals = (0, interval_1.subtractAllIntervals)(otherBonus.intervals, bonus.intervals);
            }
        }
    }
    const workDuration = ((work[1].getTime() - work[0].getTime()) / consts_1.hour);
    const results = [];
    for (const { bonus, type, intervals } of bonuses) {
        let duration = (0, interval_1.overlap)(work, intervals);
        if ((type.minDuration && duration < type.minDuration) ||
            (type.minDurationPercent && (duration / workDuration) * 100 < type.minDurationPercent)) {
            duration = 0;
        }
        let hourlyRate;
        switch (type.compType) {
            case model_1.BonusCompType.FixedAmount:
                results.push({
                    bonusId: bonus.id,
                    type: {
                        id: type.id,
                        name: type.name,
                        legalType: type.legalType,
                    },
                    taxFree: type.taxFree,
                    ancillaryCosts: 0,
                    duration,
                    wages: bonus.fixedAmount || type.fixedAmountDefault || 0,
                });
                continue;
            case model_1.BonusCompType.FixedHourlyRate:
                hourlyRate = bonus.hourlyRate || type.fixedHourlyRateDefault || 0;
                results.push({
                    bonusId: bonus.id,
                    type: {
                        id: type.id,
                        name: type.name,
                        legalType: type.legalType,
                    },
                    taxFree: type.taxFree,
                    ancillaryCosts: 0,
                    duration,
                    hourlyRate,
                    wages: (0, openapi_1.multiplyWithRate)((0, openapi_1.round)(duration, 2), hourlyRate),
                });
                continue;
            case model_1.BonusCompType.ModifiedHourlyRate: {
                hourlyRate = (0, payroll_1.getHourlyRate)(company, contract, entry.positionId);
                const percent = bonus.percent || type.defaultPercent || 0;
                const taxFreeUpToRate = type.taxFree ? type.taxFreeUpToRate : 0;
                const taxFreeRate = hourlyRate && (0, openapi_1.min)(hourlyRate, taxFreeUpToRate);
                const taxedRate = hourlyRate && (0, openapi_1.max)(0, (0, openapi_1.subtract)(hourlyRate, taxFreeUpToRate));
                if (taxFreeRate || (!hourlyRate && !!taxFreeUpToRate)) {
                    const wages = (0, openapi_1.multiplyWithPercent)((0, openapi_1.multiplyWithRate)((0, openapi_1.round)(duration, 2), taxFreeRate), percent);
                    results.push({
                        bonusId: bonus.id,
                        type: {
                            id: type.id,
                            name: type.name,
                            legalType: type.legalType,
                        },
                        taxFree: true,
                        hourlyRate: taxFreeRate,
                        ancillaryCosts: 0,
                        wages,
                        duration,
                        percent,
                    });
                }
                if (taxedRate || (!hourlyRate && !taxFreeUpToRate)) {
                    const wages = (0, openapi_1.multiplyWithPercent)((0, openapi_1.multiplyWithRate)((0, openapi_1.round)(duration, 2), taxedRate), percent);
                    const ancillaryCosts = (0, openapi_1.multiplyWithFactor)(wages, (0, payroll_1.getAncillaryCostFactor)(contract.employmentType)[0]);
                    results.push({
                        bonusId: bonus.id,
                        type: {
                            id: type.id,
                            name: type.name,
                            legalType: type.legalType,
                        },
                        taxFree: false,
                        hourlyRate: taxedRate,
                        ancillaryCosts,
                        wages,
                        duration,
                        percent,
                    });
                }
                break;
            }
        }
    }
    return results;
}
//# sourceMappingURL=bonus-result.js.map